// extracted by css-extract-rspack-plugin
export default {"editor_table":"gJKV8zqywngPObeg","actions_row":"_crImUUlW7ArgOPk","group_card":"cFpy2AMBgi8bcIu3","group_header":"OJWs2qNtSaUCjM3x","group_title":"IHpj5QhODjsEwqfl"};